module.exports = __webpack_public_path__ + "img/reason5.1df01aa6.png";